/**
 * App Pages
 */
export const APP_PAGES = {
	ROOT: "/",
	DOCUSIGN_COMPLETE: "/docusign/complete",
	BROKERS: {
		index: "/brokers",
			show: {
				index: "/brokers/:id",
				withParams: (id: string) => `/brokers/${id}`,
			},
		},
	BROKER_LIST: "/brokers/list",
	PARTNERSHIP_REQUEST_ANALYSIS: {
		index: "/brokers/partnership-request-analysis/:id",
		withParams: (id: string) => `/brokers/partnership-request-analysis/${id}`,
	},
	PROJECTS: {
		index: "/projects",
		create: "/projects/create",
		edit: {
			index: "/projects/edit/:id",
			withParams: (id: string, step?: number) => {
				const stepParamPart = step ? `?step=${step}` : "";
				return `/projects/edit/${id}${stepParamPart}`;
			},
		},
		show: {
			index: "/projects/:constructionSiteId",
			withParams: (constructionSiteId: string) => `/projects/${constructionSiteId}`,
		},
		PROJECTS_LIST: {
			index: "/projects/list",
			show: {
				index: "/projects/list/:id",
				withParams: (id: string) => `/projects/list/${id}`,
			},
		},
		submission: {
			index: "/projects/:constructionSiteId/submission",
			withParams: (constructionSiteId: string, step?: number) => {
				const stepParamPart = step ? `?step=${step}` : "";
				return `/projects/${constructionSiteId}/submission${stepParamPart}`;
			},
			participants: {
				addDesigner: "/projects/:constructionSiteId/submission/participants/add-designer",
				addDesignerWithParams: (constructionSiteId: string) =>
					`/projects/${constructionSiteId}/submission/participants/add-designer`,
				editDesigner: "/projects/:constructionSiteId/submission/participants/edit-designer/:participantId",
				editDesignerWithParams: (constructionSiteId: string, participantId: string) =>
					`/projects/${constructionSiteId}/submission/participants/edit-designer/${participantId}`,
				addBuilder: "/projects/:constructionSiteId/submission/participants/add-builder",
				addBuilderWithParams: (constructionSiteId: string) =>
					`/projects/${constructionSiteId}/submission/participants/add-builder`,
				editBuilder: "/projects/:constructionSiteId/submission/participants/edit-builder/:participantId",
				editBuilderWithParams: (constructionSiteId: string, participantId: string) =>
					`/projects/${constructionSiteId}/submission/participants/edit-builder/${participantId}`,
				addMaterial: "/projects/:constructionSiteId/submission/participants/add-material",
				addMaterialWithParams: (constructionSiteId: string) =>
					`/projects/${constructionSiteId}/submission/participants/add-material`,
				editMaterial: "/projects/:constructionSiteId/submission/participants/edit-material/:participantId",
				editMaterialWithParams: (constructionSiteId: string, participantId: string) =>
					`/projects/${constructionSiteId}/submission/participants/edit-material/${participantId}`,
			},
		},
		analysis: {
			index: "/projects/:constructionSiteId/analysis",
			withParams: (constructionSiteId: string, step?: number) => {
				const stepParamPart = step ? `?step=${step}` : "";
				return `/projects/${constructionSiteId}/analysis${stepParamPart}`;
			},
		},
		receptionAnalysis: {
			index: "/projects/:constructionSiteId/reception-analysis",
			withParams: (constructionSiteId: string, step?: number) => {
				const stepParamPart = step ? `?step=${step}` : "";
				return `/projects/${constructionSiteId}/reception-analysis${stepParamPart}`;
			},
		},
    reception: {
      index: "/projects/:constructionSiteId/reception",
      withParams: (constructionSiteId: string, step?: number) => {
        const stepParamPart = step ? `?step=${step}` : "";
        return `/projects/${constructionSiteId}/reception${stepParamPart}`;
      },
      participants: {
        addDesigner: "/projects/:constructionSiteId/reception/participants/add-designer",
        addDesignerWithParams: (constructionSiteId: string) =>
          `/projects/${constructionSiteId}/reception/participants/add-designer`,
        editDesigner: "/projects/:constructionSiteId/reception/participants/edit-designer/:participantId",
        editDesignerWithParams: (constructionSiteId: string, participantId: string) =>
          `/projects/${constructionSiteId}/reception/participants/edit-designer/${participantId}`,
        addBuilder: "/projects/:constructionSiteId/reception/participants/add-builder",
        addBuilderWithParams: (constructionSiteId: string) =>
          `/projects/${constructionSiteId}/reception/participants/add-builder`,
        editBuilder: "/projects/:constructionSiteId/reception/participants/edit-builder/:participantId",
        editBuilderWithParams: (constructionSiteId: string, participantId: string) =>
          `/projects/${constructionSiteId}/reception/participants/edit-builder/${participantId}`,
        addMaterial: "/projects/:constructionSiteId/reception/participants/add-material",
        addMaterialWithParams: (constructionSiteId: string) =>
          `/projects/${constructionSiteId}/reception/participants/add-material`,
        editMaterial: "/projects/:constructionSiteId/reception/participants/edit-material/:participantId",
        editMaterialWithParams: (constructionSiteId: string, participantId: string) =>
          `/projects/${constructionSiteId}/reception/participants/edit-material/${participantId}`,
      },
    },
		binders: {
			show: {
				index: "/projects/edit/:id/offers",
				withParams: (id: string) => `/projects/edit/${id}/offers`,
			}
		},
	},
	BINDERS: {
		index: "/binders",
		show: {
			index: "/binders/:id",
			withParams: (id: string) => `/binders/${id}`,
		},
	},
	CLIENTS: {
		index: "/clients",
		show: {
			index: "/clients/:id",
			withParams: (id: string) => `/clients/${id}`,
		},
	},
	DOCUMENT_TEMPLATES: "/document-templates",
	WEBHOOKS: "/webhooks",
	EMAIL_TEMPLATES: {
		index: "/email-templates",
		create: "/email-templates/create",
		edit: {
			index: "/email-templates/edit/:id",
			withParams: (id: string) => `/email-templates/edit/${id}`,
		},
		preview: {
			index: "/email-templates/preview/:id",
			withParams: (id: string) => `/email-templates/preview/${id}`,
		},
	},
	CONTACTS: {
		index: "/contacts",
	},
	TASKS: "/tasks",
	COMMUNICATIONS: "/communications",
	PROFILE: "/profile",
	PROPOSALS: {
		index: "/proposals",
		show: {
			index: "/proposals/:id",
			withParams: (id: string) => `/proposals/${id}`,
		},
	},
	CONTRACTS: {
		index: "/contracts",
		show: {
			index: "/contracts/:id",
			withParams: (id: string) => `/contracts/${id}`,
		},
	},
	RECEIPTS: {
	  index: "/receipts",
	  show: {
  		index: "/receipts/:id",
  		withParams: (id: string) => `/receipts/${id}`,
	  },
	},
	CLAIMS: "/claims",
	FRAMEWORK_CONTRACTS: "/framework-contracts",
	CONTRACTORS: {
		index: "/contractors",
		show: {
			index: "/contractors/:id",
			withParams: (id: string) => `/contractors/${id}`,
		},
	},
	INSURERS_MANAGEMENT: "/insurers-management",
	ACCOUNTING: "/accounting",
	GFA: {
		index: "/gfa",
		create: "/gfa/create",
		edit: {
			index: "/gfa/edit/:id",
			withParams: (id: string, step?: number) => {
				const stepParamPart = step ? `?step=${step}` : "";
				return `/gfa/edit/${id}${stepParamPart}`;
			},
		},
		show: {
			index: "/gfa/:id",
			withParams: (id: string, tab?: string) => {
				const tabParamPart = tab ? `?tab=${tab}` : "";
				return `/gfa/${id}${tabParamPart}`;
			},
		},
	},
} as const;

/**
 * Public Pages
 */
export const PAGES = {
	ROOT: "/",
	DOCUSIGN_COMPLETE: "/docusign/complete",
	ORIAS: "/auth/orias",
	SEND_EMAIL: "/send-email",
	FORGET_PASSWORD: "/auth/forget-password",
	RESET_PASSWORD: "/auth/reset-password",
	CHOOSE_PASSWORD: "/auth/choose-password",
	LOGIN: "/login",
	CONSTRUCTION_SITE_COMPLETE: {
		index: "/construction-sites/:id/complete",
		withParams: (id: string) => `/construction-sites/${id}/complete`,
	},
	PARTNERSHIP_REQUEST_ANALYSIS: APP_PAGES.PARTNERSHIP_REQUEST_ANALYSIS,
	REGISTER_BROKER_MAIN_DETAILS: "/register-broker-main-details",
	REGISTER_BROKER_SECOND_STEP: {
		index: "/register-broker-second-step",
		withBrokerId: "/register-broker-second-step/:brokerId",
		withParams: (brokerId?: string) => 
			brokerId ? `/register-broker-second-step/${brokerId}` : "/register-broker-second-step"
	},
	BROKERS: APP_PAGES.BROKERS,
	BROKER_LIST: APP_PAGES.BROKER_LIST,
	PROJECTS: APP_PAGES.PROJECTS,
	BINDERS: APP_PAGES.BINDERS,
	CLIENTS: APP_PAGES.CLIENTS,
	DOCUMENT_TEMPLATES: APP_PAGES.DOCUMENT_TEMPLATES,
	WEBHOOKS: APP_PAGES.WEBHOOKS,
	EMAIL_TEMPLATES: APP_PAGES.EMAIL_TEMPLATES,
	CONTACTS: APP_PAGES.CONTACTS,
	TASKS: APP_PAGES.TASKS,
	COMMUNICATIONS: APP_PAGES.COMMUNICATIONS,
	PROFILE: APP_PAGES.PROFILE,
	PROPOSALS: APP_PAGES.PROPOSALS,
	CONTRACTS: APP_PAGES.CONTRACTS,
	RECEIPTS: APP_PAGES.RECEIPTS,
	CLAIMS: APP_PAGES.CLAIMS,
	FRAMEWORK_CONTRACTS: APP_PAGES.FRAMEWORK_CONTRACTS,
	CONTRACTORS: APP_PAGES.CONTRACTORS,
	INSURERS_MANAGEMENT: APP_PAGES.INSURERS_MANAGEMENT,
	ACCOUNTING: APP_PAGES.ACCOUNTING,
	GFA: APP_PAGES.GFA,
} as const;
